import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";

import { fetchItem } from "../../actions/paintingActions";
import { getPainting } from "../../selectors/paintings";
import { PAINTING_SHAPE } from "../../constants/paintingConstants";
import LoadableEntity from "../../components/ui/loadable/entity";
import NotFound from "../../screens/static/not_found";


export function withPainting(WrappedComponent) {

    const WithPainting = class extends Component {

      componentDidMount() {
        this.fetchPainting();
      }

      fetchPainting = () => {
        const { match } = this.props;
        const paintingId = match.params["id"];

        this.props.fetchItem(paintingId);
      };

      render() {
        const { painting, fetchStatus, ...restProps } = this.props;

        return (
          <LoadableEntity
            entity={painting}
            renderError={() => <NotFound/>}
            // renderLoading={() => <LoadingPage/>}
          >
            {
              (painting) =>
                <WrappedComponent
                  {...restProps}
                  painting={painting}
                  fetchPainting={this.fetchPainting}
                />
            }
          </LoadableEntity>
        )
      }
    };

    WithPainting.propTypes = {
      painting: PropTypes.shape(PAINTING_SHAPE),
    };

    function mapStateToProps(state, {match}) {
      const paintingId = parseInt(match.params["id"]);

      return {
        painting: getPainting(state, paintingId),
      }
    }

    function mapDispatchToProps(dispatch) {
      return bindActionCreators({
        fetchItem,
      }, dispatch)
    }

    return compose(
      withRouter,
      connect(mapStateToProps, mapDispatchToProps)
    )(WithPainting)
  }
